<span class="updateFontStyle">
  <input matInput [placeholder]="searchPlaceHolder" [matAutocomplete]="auto" [formControl]="txtCtrl"
       (keyup.enter)="keyupEnter()" [(ngModel)]="txtVal" (ngModelChange)="updatedVal($event)">
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option [ngClass]="{'hide-autocomplete': !showAutocomplete}" *ngFor="let data of filteredListData | async" [value]="data" (click)="optionClick()">
      <span>{{ data }}</span>
    </mat-option>
  </mat-autocomplete>
</span>
